import clsx from 'clsx';
import React from 'react';
type LoadingButtonProps = {
  type?: 'button' | 'submit' | 'reset';
  isLoading?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
  onClick?: () => void;
};
const SubmitButton: React.FC<LoadingButtonProps> = ({
  type = 'button',
  isLoading = false,
  disabled = false,
  children,
  onClick,
}) => {
  const isDisabled = disabled || isLoading;
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={isDisabled}
      className={clsx(
        'px-6 py-4 rounded-lg font-medium transition-all flex items-center justify-center gap-2',
        'bg-btn-gradient hover:bg-btn-gradient text-white',
        {
          'opacity-60 cursor-not-allowed': isDisabled,
          'hover:bg-[#0a2a37]-600': !isDisabled,
        }
      )}
    >
      {isLoading && (
        <span className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
      )}
      <span>{isLoading ? 'Saving...' : children}</span>
    </button>
  );
};

export default SubmitButton;
